import axios from 'axios'
import url from '../urls'

export default {
  addSample(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(url.TyperSampleUrl, data)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },
  getSamples() {
    return new Promise((resolve, reject) => {
      axios
        .get(url.TyperSampleUrl)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },
  updateSample(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(url.TyperSampleUrl, data)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },
  deleteSample(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${url.TyperSampleUrl}/${id}`)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  }
}
